"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.injectPropsIfTargetNotExisted = void 0;
var tslib_1 = require("tslib");
function injectPropsIfTargetNotExisted(columns, targetColumnKey, columnProps, postposition) {
    if (columnProps === void 0) { columnProps = {}; }
    if (postposition === void 0) { postposition = false; }
    // 查找注入的目标列
    var targetColumnIndex = -1;
    if (targetColumnKey) {
        targetColumnIndex = columns.findIndex(function (x) { return x.key === targetColumnKey; });
        if (targetColumnIndex === -1) {
            console.warn("Table addon can not find column \"" + targetColumnKey + "\", did you rename or misspell it?");
        }
    }
    // 没有目标列，创建一个列
    if (+targetColumnIndex === -1) {
        columnProps.ignore = true;
        return postposition ? tslib_1.__spread(columns, [columnProps]) : tslib_1.__spread([columnProps], columns);
    }
    return columns;
}
exports.injectPropsIfTargetNotExisted = injectPropsIfTargetNotExisted;
//# sourceMappingURL=inject-props-if-target-not-existed.js.map